import _ from 'lodash';
import angular from 'angular';

class FolioController {
  /* @ngInject */
  constructor(
    $rootScope,
    $scope,
    $state,
    $location,
    $document,
    $window,
    HelperService
  ) {
    const vm = this;

    vm.$onInit = () => {
      vm.artist = vm.folio.fields.artist[0];
      vm.assets = HelperService.group(vm.folio.fields.assets);

      vm.unmuteVideo = !$state.history[0];

      $rootScope.pageTitle = [vm.artist.title, vm.folio.title].join(' — ');
      // $rootScope.pageDescription = ''

      $rootScope.socialImage(
        HelperService.thumbnailSrc(
          vm.assets[0].entities[0].thumbnail,
          'h:1000;q:80;f:jpg'
        )
      );

      function getIndex() {
        return _.findIndex(
          vm.assets,
          (group) =>
            group.entities[0].id === $location.search().i ||
            (group.entities[1] && group.entities[1].id === $location.search().i)
        );
      }

      vm.index = getIndex();

      $scope.$on('$locationChangeSuccess', () => {
        vm.index = getIndex();
      });

      vm.preloadSlide = (index) => {
        const video =
          vm.assets[index].entities.filter(
            (entity) => entity.schema === 'video'
          ).length > 0;

        if (index !== vm.index && video) {
          return false;
        }

        return Math.abs(vm.index - index) <= 1;
      };

      vm.nextSlideId = (index) => {
        const i = index === vm.assets.length - 1 ? 0 : index + 1;
        return vm.assets[i].entities[0].id;
      };

      const nextSlide = () => {
        const i = vm.index === vm.assets.length - 1 ? 0 : vm.index + 1;
        $location.search({ i: vm.assets[i].entities[0].id });
      };

      const prevSlide = () => {
        const i = vm.index === 0 ? vm.assets.length - 1 : vm.index - 1;
        $location.search({ i: vm.assets[i].entities[0].id });
      };

      const keyDown = (event) => {
        if (vm.index > -1) {
          if (event.keyCode === 39) {
            $scope.$apply(() => {
              nextSlide();
            });
          }
          if (event.keyCode === 37) {
            $scope.$apply(() => {
              prevSlide();
            });
          }
        }
      };

      angular.element($document[0].body).on('keydown', keyDown);

      $scope.$on('$destroy', () => {
        angular.element($document[0].body).off('keydown', keyDown);
      });

      vm.clickSlides = (event, prev) => {
        event.preventDefault();
        if (prev) {
          prevSlide();
        } else {
          nextSlide();
        }
      };

      vm.getThumbnailUrl = (id) =>
        $state.href($state.$current.name, {
          artistSlug: vm.artist.slug,
          folioSlug: vm.folio.slug,
          i: id,
        });

      vm.getFolioUrl = () =>
        $state.href($state.$current.name, {
          artistSlug: vm.artist.slug,
          folioSlug: vm.folio.slug,
          i: null,
        });

      vm.getSearchUrl = () => {
        if (!vm.assets[vm.index]) {
          return $state.href('index.search');
        }
        const tags = [];
        const categories = [];
        const terms = [];
        // const modifier = '-';
        const modifier = '';
        vm.assets[vm.index].entities.forEach((asset) => {
          if (asset.fields.tags && asset.fields.tags.terms) {
            asset.fields.tags.terms.forEach((term) => {
              tags.push(term.slug);
            });
          }
          if (asset.fields.categories && asset.fields.categories.terms) {
            asset.fields.categories.terms.forEach((term) => {
              categories.push(term.slug);
            });
          }
          if (asset.fields.artist && asset.fields.artist[0]) {
            terms.push(asset.fields.artist[0].title);
          }
          if (asset.fields.caption) {
            terms.push(modifier + asset.fields.caption);
          }
          if (asset.fields.project) {
            terms.push(modifier + asset.fields.project);
          }
          if (asset.fields.client) {
            terms.push(modifier + asset.fields.client);
          }
        });
        return $state.href('index.search', {
          tags,
          categories,
          terms,
        });
      };

      vm.getPerRow = () => {
        return $window.innerWidth > 768 ? 4 : 2;
      };

      vm.getAverageRatio = () => {
        return $window.innerWidth > 768 ? 0.75 : 0.75;
      };

      vm.getGutter = () => {
        return (10 / Math.min(1650, $window.innerWidth)) * 100;
      };
    };
  }
}

export default FolioController;
